export enum EventTypeEnum {
  Invalid,
  List,
  Message,
  ListField,
  Extract
}
